import { Injectable } from '@angular/core';
import { AES, enc } from 'crypto-ts';
import { environment } from '../../../environments/environment';
import DeviceUUID from 'device-uuid';

/**
 * Encrypted localStorage wrapper untuk menyimpan data sensitif (token, dll).
 * Menggunakan AES dengan key turunan dari app secret.
 */
@Injectable({ providedIn: 'root' })
export class EncryptedStorageService {
    private readonly key: string;
    private readonly prefix = 'kai_';
    private device = new DeviceUUID();

    constructor() {
        this.key = `${environment.appName}::${environment.version}::stock-opname-secure:${this.device.get()}`;
    }

    set<T>(name: string, value: T): void {
        try {
            const json = JSON.stringify(value);
            const encrypted = AES.encrypt(json, this.key).toString();
            localStorage.setItem(this.prefix + name, encrypted);
        } catch {
            localStorage.removeItem(this.prefix + name);
        }
    }

    get<T>(name: string): T | null {
        try {
            const encrypted = localStorage.getItem(this.prefix + name);
            if (!encrypted) return null;
            const decrypted = AES.decrypt(encrypted, this.key).toString(enc.Utf8);
            if (!decrypted) return null;
            return JSON.parse(decrypted) as T;
        } catch {
            return null;
        }
    }

    remove(name: string): void {
        localStorage.removeItem(this.prefix + name);
    }

    clear(): void {
        const keys = Object.keys(localStorage).filter((k) => k.startsWith(this.prefix));
        keys.forEach((k) => localStorage.removeItem(k));
    }
}
